export const debounce = (func, wait) => {
    let timeout = null;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(
            () => func.apply(context, args),
            wait
        );
    };
};

export const throttle = (func, wait) => {
    let throttling;
    return function(...args) {
        const context = this;
        if (!throttling) {
            func.apply(context, args);
            throttling = true;
            setTimeout(
                () => throttling = false,
                wait
            );
        }
    };
};

export const delay = (durationMs) => (
    new Promise(resolve => setTimeout(resolve, durationMs))
);

